var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { PopupMessageDefaultConfig } from "./PopupMessageConstants";
import { Header, Body } from "./components";
var PopupMessage = /** @class */ (function (_super) {
    __extends(PopupMessage, _super);
    function PopupMessage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { config: __assign({}, PopupMessageDefaultConfig, props.config) };
        return _this;
    }
    PopupMessage.getDerivedStateFromProps = function (nextProps, prevState) {
        return {
            config: __assign({}, prevState.config, nextProps.config)
        };
    };
    PopupMessage.prototype.render = function () {
        return (React.createElement("div", { className: "rj-popup-message " + this.state.config.type + " " + this.state.config.className },
            this.state.config.header.length > 0 && React.createElement(Header, { html: this.state.config.header }),
            this.state.config.body.length > 0 && React.createElement(Body, { html: this.state.config.body, actions: this.state.config.actions }),
            this.props.children));
    };
    return PopupMessage;
}(React.Component));
export { PopupMessage };
//# sourceMappingURL=PopupMessage.js.map